import ConditionalSpinner from "../../../../components/ConditionalSpinner";
import { useView } from "../../../../hooks/useView";
import { VizContainerProps } from "../VizContainer";
import { LargeIconList } from "./LargeIconList";
import { DetailList } from "./DetailList";
import "./VizList.scss";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import * as AnalyticsStore from "../../../../store/analytics/Analytics";
import { DataDescriptions } from "../../../../models/viz/dataDescriptions/GenericVideoEventDataDescription";

export type VizListProps = VizContainerProps;

export function VizList(props: VizListProps) {
    const dispatch = useDispatch();
    const { view } = useView(props.viewId);

    const isLoading = view?.data.state != "loaded";
    const hasData =
        view?.currentDataDescription?.type !== DataDescriptions.standardMovement.type && view?.entities?.length;

    const renderList = () => {
        switch (view?.representation) {
            case "large-icons":
                return <LargeIconList viewId={props.viewId} />;
            case "detail-list":
                return <DetailList viewId={props.viewId} />;
        }
    };

    // Switch to non-movement data description
    useEffect(() => {
        if (view?.currentDataDescription?.type === DataDescriptions.standardMovement.type) {
            const desc = view.dataDescriptions.find((d) => d.type !== DataDescriptions.standardMovement.type);

            if (desc !== undefined) {
                dispatch(AnalyticsStore.actionCreators.setViewDataDescription(view.viewId, desc));
            }
        }
    }, [view?.currentDataDescription?.type]);

    return (
        <div
            className={`viz-list viz-list-${view?.representation} ${
                isLoading || !hasData ? " d-flex justify-content-center" : ""
            }`}
        >
            <ConditionalSpinner isLoading={isLoading}>
                {hasData ? (
                    renderList()
                ) : (
                    <div className="py-4 d-flex justify-content-center align-items-center">
                        <p>No data available for this media source</p>
                    </div>
                )}
            </ConditionalSpinner>
        </div>
    );
}
